import config from "../config";

/**
 * The single place that knows where the ICMS API lives and how its URLs are built.
 *
 * Every service module (analyticsApi, assistantApi, claimsApi, authApi, pocApi,
 * vehicleCatalogue) builds its URLs through these helpers, so components never
 * concatenate config.API_BASE_URL themselves. config.API_BASE_URL is read on each
 * call (not captured at import), exactly as the components did before.
 *
 * Session-cookie auth for fetch() calls is added by utils/authInterceptor.js, which
 * recognises API calls by apiOrigin().
 */

/** Absolute URL of an API path such as "/chat" or "/forecast-claims/". */
export const apiUrl = (path) => `${config.API_BASE_URL}${path}`;

/** Origin (scheme + host + port) of the API; /auth/* routes live at the origin, outside /api. */
export const apiOrigin = () => new URL(config.API_BASE_URL, window.location.origin).origin;

/** The backend sign-in URL, forwarding a login_hint this page received (e.g. from iai_portal) for silent SSO. */
export function buildLoginUrl(origin = apiOrigin()) {
  const loginHint = new URLSearchParams(window.location.search).get("login_hint");
  const loginUrl = `${origin}/auth/login`;
  return loginHint ? `${loginUrl}?login_hint=${encodeURIComponent(loginHint)}` : loginUrl;
}

const JSON_HEADERS = { "Content-Type": "application/json" };

/** POST a JSON body; resolves to the fetch Response (callers keep their own status handling). */
export const postJson = (path, body) =>
  fetch(apiUrl(path), { method: "POST", headers: JSON_HEADERS, body: JSON.stringify(body) });

/** GET with a JSON content-type header; resolves to the fetch Response. */
export const getWithJsonHeader = (path) => fetch(apiUrl(path), { method: "GET", headers: JSON_HEADERS });
